// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"register_registerForm__1-Aw1","codeInput":"register_codeInput__2tNjH","formStepSix":"register_formStepSix__31mF9","listPassword":"register_listPassword__-5ZgB"};